
























































































































































































































import { Component, Vue } from "vue-property-decorator";
import { body, Sn, Dt } from "@/apis/keio/@types";
import { OdptDirection } from "@/odpt.ts";
import { SecinfoKO, SecinfoS, TrainKO, TrainS } from "@/types";
import LineSectionKO from "@/components/LineSectionKO.vue";
import LineSectionS from "@/components/LineSectionS.vue";
import moment from "moment";
import kostl from "@/apis/kostl/$api";
import keio from "@/apis/keio/$api";
import odpt from "aspida-odpt";
import aspida from "@aspida/axios";
import { UnyoList } from "@/apis/kostl/vehicles/@types";
import { capitalMap, ikListKO, typeList } from "@/list";

@Component({
  components: {
    LineSectionKO,
    LineSectionS
  }
})
export default class Home extends Vue {
  loading: boolean = true;
  infoKO: SecinfoKO[] = [];
  dateKO: Dt[] = [];
  infoS: SecinfoS[] = [];
  dateS = moment();
  unyoList: UnyoList = {};
  error = null;
  intervalId: any = "";

  created() {
    this.fetchData();
    this.intervalId = setInterval(this.fetchData, 5000);
  }

  beforeDestroy() {
    clearInterval(this.intervalId);
  }

  get getTimeKO(): string {
    if (this.dateKO.length) {
      const dt: Dt = this.dateKO[0];
      let m = moment([+dt.yy, +dt.mt - 1, +dt.dy, 0, +dt.mm, +dt.ss]);
      m.hour(+dt.hh);
      return m.format("YYYY.MM.DD HH:mm:ss");
    }
    return moment().format("YYYY.MM.DD HH:mm:ss");
  }
  get getTimeS(): string {
    return this.dateS.format("YYYY.MM.DD HH:mm:ss");
  }

  async fetchData() {
    this.loading = true;

    // Keio
    keio(aspida())
      .traffic_info_json.$get()
      .then(res => {
        const resKO = new Map<string, TrainKO[]>();
        const resultKO: SecinfoKO[] = [];

        // Record Date and Time
        this.dateKO = res.up[0].dt;

        // Train Stopping
        if ("TS" in res) {
          for (const station of res.TS) {
            if (station.sn !== Sn.I) {
              for (const train of station.ps) {
                const pos = `${station.id}-${train.bs}`;
                if (!resKO.has(pos)) resKO.set(pos, []);
                const inf = this.parseInformation(
                  train.inf,
                  +train.sy,
                  !!+train.ki
                );
                resKO.get(pos)!.push({
                  tr: train.tr.trim(),
                  sy: inf.sy || train.sy,
                  ki: !!+train.ki,
                  dl: +train.dl,
                  ik: inf.ik || train.ik_tr
                });
              }
            }
          }
          for (const key of resKO.keys()) {
            resultKO.push({
              pos: key,
              trains: resKO.get(key)!
            });
          }
        }

        // Train Bounding
        if ("TB" in res) {
          for (const station of res.TB) {
            if (station.sn !== Sn.I && typeof station !== "undefined") {
              const pos = station.id;
              resultKO.push({
                pos: pos,
                trains: station.ps.map(train => {
                  const inf = this.parseInformation(
                    train.inf,
                    +train.sy,
                    !!+train.ki
                  );
                  return {
                    tr: train.tr.trim(),
                    sy: inf.sy || train.sy,
                    ki: !!+train.ki,
                    dl: +train.dl,
                    ik: inf.ik || train.ik_tr
                  };
                })
              });
            }
          }
        }

        // Splice (Vue Constraints)
        this.infoKO.splice(0, this.infoKO.length, ...resultKO);
      });

    // Odpt
    odpt(aspida())
      .v4.odpt_3ATrain.$get({
        query: {
          "odpt:railway": "odpt.Railway:Toei.Shinjuku",
          "acl:consumerKey": process.env.VUE_APP_ODPT_TOKEN
        }
      })
      .then(res => {
        const resS = new Map<string, TrainS[]>();
        const resultS: SecinfoS[] = [];

        for (const train of res) {
          // Record Date and Time
          this.dateS = moment.max(moment(this.dateS), moment(train["dc:date"]));

          // Generate Position Keys
          const pos =
            (train["odpt:railDirection"] === OdptDirection.E ? "E" : "W") +
            (this.s_stations.indexOf(
              train["odpt:fromStation"]!.split(".").pop()!
            ) +
              1) +
            (train["odpt:toStation"]
              ? "-" +
                (this.s_stations.indexOf(
                  train["odpt:toStation"].split(".").pop()!
                ) +
                  1)
              : "");

          // Push to Object
          if (!resS.has(pos)) resS.set(pos, []);
          resS.get(pos)!.push({
            tr: train["odpt:trainNumber"],
            sy: train["odpt:trainType"]!.split(".").pop()!,
            ki: train["odpt:railDirection"] === OdptDirection.W,
            dl: train["odpt:delay"]!,
            ik: train["odpt:destinationStation"]![0].split(".").pop()!,
            op: train["odpt:operator"].split(".").pop()!
          });
        }

        // Convert to Array
        for (const key of resS.keys()) {
          resultS.push({
            pos: key,
            trains: resS.get(key)!
          });
        }

        // Splice (Vue Constraints)
        this.infoS.splice(0, this.infoS.length, ...resultS);
      });

    // Kostl (Unyo)
    kostl(aspida())
      .vehicles.$get()
      .then(data => {
        this.unyoList = Object.assign({}, this.unyoList, data);
      });

    this.loading = false;
  }

  parseInformation(
    raw: string,
    sy: number,
    ki: boolean
  ): { sy: string | null; ik: string | null } {
    if (raw !== "") {
      const removeRegExp = /この列車は|駅で|\s|行きとなります。/;
      const arr = raw.split(removeRegExp);
      if (arr.length === 5) {
        let data = {
          chgSta: arr[1],
          destSta: arr[3],
          newType: arr[2]
        } as { chgSta: string; destSta: string; newType: string | null };
        for (const [key, value] of capitalMap) {
          if (value === data.chgSta) data.chgSta = key;
          if (value === data.destSta) data.destSta = key;
        }
        data.newType =
          Object.keys(typeList).find(key => typeList[+key] === data.newType) ||
          "";
        if (!ki && data.newType !== "")
          [data.newType, sy] = [`${sy}`, +data.newType];
        return {
          ik:
            Object.keys(ikListKO).find(
              // eslint-disable-next-line no-irregular-whitespace
              key => ikListKO[key] === `${data.chgSta}　${data.destSta}`
            ) || null,
          sy: data.newType ? `${sy}${data.newType}` : null
        };
      }
    }
    return { sy: null, ik: null };
  }

  readonly s_stations = [
    "Shinjuku",
    "ShinjukuSanchome",
    "Akebonobashi",
    "Ichigaya",
    "Kudanshita",
    "Jimbocho",
    "Ogawamachi",
    "Iwamotocho",
    "BakuroYokoyama",
    "Hamacho",
    "Morishita",
    "Kikukawa",
    "Sumiyoshi",
    "NishiOjima",
    "Ojima",
    "HigashiOjima",
    "Funabori",
    "Ichinoe",
    "Mizue",
    "Shinozaki",
    "Motoyawata"
  ];

  stations_main = [
    "本八幡",
    "篠崎",
    "瑞江",
    "一之江",
    "船堀",
    "東大島",
    "大島",
    "西大島",
    "住吉",
    "菊川",
    "森下",
    "浜町",
    "馬喰横山",
    "岩本町",
    "小川町",
    "神保町",
    "九段下",
    "市ヶ谷",
    "曙橋",
    "新宿三丁目",
    "新宿",
    "初台",
    "幡ヶ谷",
    "笹塚",
    "代田橋",
    "明大前",
    "下高井戸",
    "桜上水",
    "上北沢",
    "八幡山",
    "芦花公園",
    "千歳烏山",
    "仙川",
    "つつじヶ丘",
    "柴崎",
    "国領",
    "布田",
    "調布",
    "西調布",
    "飛田給",
    "武蔵野台",
    "多磨霊園",
    "東府中",
    "府中",
    "分倍河原",
    "中河原",
    "聖蹟桜ヶ丘",
    "百草園",
    "高幡不動",
    "南平",
    "平山城址公園",
    "長沼",
    "北野",
    "京王八王子 "
  ];
  stations_sagami = [
    "京王多摩川",
    "京王稲田堤",
    "京王よみうりランド",
    "稲城",
    "若葉台",
    "京王永山",
    "京王多摩センター",
    "京王堀之内",
    "南大沢",
    "多摩境",
    "橋本"
  ];
  stations_takao = ["京王片倉", "山田", "めじろ台", "狭間", "高尾", "高尾山口"];
}
